import React from "react";
import "./Uploader.css";

export default function Uploader({
  register,
  name,
  btnText,
  errors,
  validations,
  multiple = false,
}) {
  const activateUploader = () => {
    const fileInput = document.getElementById("uploader");
    fileInput.click();
  };

  return (
    <>
      <input
        {...register(name, {
          ...validations,
        })}
        id="uploader"
        type="file"
        style={{ display: "none" }}
        multiple={multiple}
      />
      <button
        className="upload-btn py-2 px-3"
        onClick={activateUploader}
        type="button"
      >
        {btnText}
      </button>
      {errors && (
        <p className="text-danger mb-0">{errors.message || errors.type}</p>
      )}
    </>
  );
}
